(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/hooks/use-draw-subscription.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/hooks/use-draw-subscription.js');
"use strict";

const _excluded = ["isLightUpdate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const {
  useSocket
} = svs.components.lbUtils.socket;
const {
  products
} = svs.utils;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  updateDraw
} = svs.components.sport.drawsRedux.actions;
const {
  globalizedSelectors
} = svs.components.sport.drawsRedux;

const useDrawSubscription = function (drawNumber, productId) {
  let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const dispatch = useDispatch();
  const subscriptionUrl = "/draw/1/".concat(products.getSpecificDrawName(productId), "/draws/").concat(drawNumber);
  const draw = useSelector(state => globalizedSelectors.selectById(state, drawId));
  const {
      isLightUpdate
    } = opts,
    restOpts = _objectWithoutProperties(opts, _excluded);
  const socketOptions = _objectSpread({
    sendInitialUpdate: false,
    skip: false
  }, restOpts);
  useSocket(subscriptionUrl, drawResponse => {
    if (drawResponse) {
      dispatch(updateDraw({
        drawResponse: drawResponse.draw
      }, {
        isLightUpdate
      }));
    }
  }, _objectSpread(_objectSpread({}, socketOptions), {}, {
    skip: restOpts.skip || !(productId || drawNumber)
  }));
  return draw;
};
setGlobal('svs.components.sport.drawsRedux.hooks', {
  useDrawSubscription
});

 })(window);